var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"star-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","aria-hidden":"true"}},[_c('path',{attrs:{"d":"m7 10.847 4.12 2.486-1.093-4.686 3.64-3.154-4.793-.406L7 .667l-1.873 4.42-4.794.406 3.64 3.154-1.093 4.686L7 10.847Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }